<template>
    
    <div>
        <div v-for="option in filter.inputs.level.options"  :key="option.value" class="form-group">
            <label :for="`level-${option.value}`" class="form-label">
                <input :id="`level-${option.value}`" v-model="level" type="radio" :value="option.value"> 
                {{ option.label }}
            </label>
        </div>  

        <div class="form-group ">
            <label for="" class="form-label label-block">{{ filter.inputs.campaigns.label }}</label>
            <div class="form-input m-0 dblock">
                 <label v-for="option in filter.inputs.campaigns.options" :key="option.value" :for="`campaign-${option.value}`" class="form-label label-block">
                    <input :id="`campaign-${option.value}`" v-model="campaigns" type="checkbox" :value="option.value"> 
                    {{ option.label }}
                </label>
            </div>
        </div>
        <div class="form-group">
            <label for="" class="form-label label-block">{{ filter.inputs.consent.label }}</label>
            <div class="form-input">
                <label v-for="option in filter.inputs.consent.options" :key="option.value" :for="`${option.value}-consent`" class="form-label label-block">
                    <input :id="`${option.value}-consent`" v-model="consent" type="radio" :value="option.value"> 
                    {{ option.label }}
                </label>
            </div>
        </div>

        <div v-if="consent == 'with'" class="form-group">
            <label for="" class="form-label">{{ filter.inputs.date.label }}</label>
            <div class="form-input">
                <select id="" v-model="date" name="">
                    <option v-for="option in filter.inputs.date.options" :key="option.value" :value="option.value" v-text="option.label" />
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins	: [
        ListingFilterMixin
    ],
    data(){
        return {
            level : '',
            consent : '',
            campaigns : [],
            date : '',
        }
    },

    computed : {
        data(){
            return {
                level : this.level,
                consent : this.consent,
                campaigns : this.campaigns,
                date : this.date
            }
        }
    }
}
</script>
